import { baseProdConfig } from "./baseEnv";

export const prodConfig = {
  ...baseProdConfig,
  WEB_VIEWER_BASE_URL: "https://webviewer2.archform.com",
  WEB_EDITOR_BASE_URL: "https://webeditor.archform.com",
  ARCHFORM_DASH_V1_BASE_URL: "https://dashboard1.archform.com",
  FILE_SUFFIX: ""
}